import { render } from "./CountUpDecimal.vue?vue&type=template&id=449ad3b0"
import script from "./CountUpDecimal.vue?vue&type=script&lang=js"
export * from "./CountUpDecimal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__